var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import { styled, createGlobalStyle, ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useOutside } from '@hn-front/utils';
import { AccordionList } from './AccordionList';
import { Progress } from './Progress';
import theme from '../../../landing/components/core/themes/theme';
import { Content } from './Content';
import { useGetStartedData } from './api';
import { Modal } from '../../../landing/components/core/modals';
import { VideoPlayer } from './VideoPlayer';
var GlobalStyle = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  body, input {\n    font-family: 'Noto Sans', sans-serif;\n    font-weight: 400;\n    color: ", ";\n  }\n  div, section, main {\n    box-sizing: border-box;\n  }\n  a {\n    text-decoration: none;\n    &:hover {\n      color: ", ";\n    }\n    &, &:focus {\n      color: ", ";\n    }\n  }\n  button {\n    border: none;\n    &:hover {\n      cursor: pointer;\n    }\n  }\n  p, h1, h2, h3 {\n    margin: 0;\n  }\n"], ["\n  body, input {\n    font-family: 'Noto Sans', sans-serif;\n    font-weight: 400;\n    color: ", ";\n  }\n  div, section, main {\n    box-sizing: border-box;\n  }\n  a {\n    text-decoration: none;\n    &:hover {\n      color: ", ";\n    }\n    &, &:focus {\n      color: ", ";\n    }\n  }\n  button {\n    border: none;\n    &:hover {\n      cursor: pointer;\n    }\n  }\n  p, h1, h2, h3 {\n    margin: 0;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.blackText;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primaryHover;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
});
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-bowdbe" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  max-width: 1024px;\n  margin: 0 auto;\n  justify-content: center;\n"], ["\n  display: flex;\n  flex-flow: column;\n  max-width: 1024px;\n  margin: 0 auto;\n  justify-content: center;\n"])));
var Header = styled.header.withConfig({ displayName: "Header", componentId: "sc-tk11t2" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 32px;\n"], ["\n  display: flex;\n  flex-flow: column;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 32px;\n"])));
var Title = styled.h1.withConfig({ displayName: "Title", componentId: "sc-19ik0qg" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-weight: 700;\n  font-size: 32px;\n  line-height: 40px;\n  letter-spacing: -0.6px;\n  margin: 0 0 16px 0;\n  text-align: center;\n"], ["\n  font-weight: 700;\n  font-size: 32px;\n  line-height: 40px;\n  letter-spacing: -0.6px;\n  margin: 0 0 16px 0;\n  text-align: center;\n"])));
var SubTitle = styled.p.withConfig({ displayName: "SubTitle", componentId: "sc-1j70obe" })(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-size: 16px;\n  line-height: 24px;\n  margin: 0 0 24px 0;\n  text-align: center;\n"], ["\n  font-size: 16px;\n  line-height: 24px;\n  margin: 0 0 24px 0;\n  text-align: center;\n"])));
var ScAccordionList = styled(AccordionList).withConfig({ displayName: "ScAccordionList", componentId: "sc-mzx5mi" })(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin-bottom: 48px;\n"], ["\n  margin-bottom: 48px;\n"])));
var Loading = styled.p.withConfig({ displayName: "Loading", componentId: "sc-1e960l" })(templateObject_7 || (templateObject_7 = __makeTemplateObject([""], [""])));
var GetStartedApp = function (_a) {
    var groupId = _a.groupId, rest = __rest(_a, ["groupId"]);
    var _b = useState(false), videoWatched = _b[0], setVideoWatched = _b[1];
    var _c = useState(false), passwordsProvided = _c[0], setPasswordsProvided = _c[1];
    var _d = useGetStartedData({ groupId: groupId }), data = _d.data, isLoading = _d.isLoading;
    var _e = useState('none'), video = _e[0], setVideo = _e[1];
    var refModal = useRef(null);
    useOutside(refModal, function () { return setVideo('none'); });
    var onPasswordOpen = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if ((data === null || data === void 0 ? void 0 : data.passwordsProvided) || !((_a = data === null || data === void 0 ? void 0 : data.groupInfo) === null || _a === void 0 ? void 0 : _a.id))
                        return [2 /*return*/];
                    return [4 /*yield*/, fetch("/api/teachers/groups/" + data.groupInfo.id + "/passwords_provided", {
                            method: 'POST',
                        })];
                case 1:
                    _b.sent();
                    setPasswordsProvided(true);
                    return [2 /*return*/];
            }
        });
    }); }, [data]);
    var onPlayVideo = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(!(data === null || data === void 0 ? void 0 : data.videoWatched) && ((_a = data === null || data === void 0 ? void 0 : data.groupInfo) === null || _a === void 0 ? void 0 : _a.id))) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetch("/api/teachers/groups/" + groupId + "/experience_video", {
                            method: 'POST',
                        })];
                case 1:
                    _b.sent();
                    setVideoWatched(true);
                    _b.label = 2;
                case 2:
                    setVideo('student');
                    return [2 /*return*/];
            }
        });
    }); }, [data]);
    var onPlayIntroVideo = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setVideo('intro');
            return [2 /*return*/];
        });
    }); }, [data]);
    useEffect(function () {
        if (data)
            setVideoWatched(data.videoWatched);
    }, [data]);
    useEffect(function () {
        if (data)
            setPasswordsProvided(data.passwordsProvided);
    }, [data]);
    if (isLoading)
        return (_jsx(Container, __assign({}, rest, { children: _jsx(Loading, { children: "Loading..." }, void 0) }), void 0));
    if (!data)
        return _jsx(Container, __assign({}, rest), void 0);
    var maxSteps = data.placementTestAvailable ? 6 : 5;
    var stepsPassed = 2;
    if (videoWatched)
        stepsPassed += 1;
    if (passwordsProvided)
        stepsPassed += 1;
    if (data.studentLogins)
        stepsPassed += 1;
    if (data.placementTestCompleted && data.placementTestAvailable)
        stepsPassed += 1;
    return (_jsxs(Container, __assign({}, rest, { children: [_jsxs(Header, { children: [_jsx(Title, { children: "Happy Numbers Starter Checklist" }, void 0), _jsxs(SubTitle, { children: ["Complete the remaining steps below for a quick start. For your convenience, the checklist", _jsx("br", {}, void 0), "will be always available on the Get Started button at the top of the page."] }, void 0), _jsx(Progress, { start: stepsPassed, end: maxSteps }, void 0)] }, void 0), _jsx(ScAccordionList, { data: data, onPasswordOpen: onPasswordOpen, onPlayVideo: onPlayVideo, videoWatched: videoWatched, passwordsProvided: passwordsProvided }, void 0), _jsx(Content, { onOpen: onPlayIntroVideo }, void 0), video !== 'none' && (_jsx(Modal, __assign({ onClose: function () { return setVideo('none'); }, ref: refModal }, { children: _jsx(VideoPlayer, { src: video === 'student'
                        ? 'https://www.youtube.com/embed/C8vWZYiG9Lg'
                        : 'https://www.youtube.com/embed/ihi0FFjYafw', autoplay: true }, void 0) }), void 0))] }), void 0));
};
var GetStarted = function (_a) {
    var groupId = _a.groupId;
    return (_jsxs(ThemeProvider, __assign({ theme: theme }, { children: [_jsx(GlobalStyle, {}, void 0), _jsx(Router, __assign({ basename: "/teachers/g/" + groupId + "/guide-manual" }, { children: _jsx(Routes, { children: _jsx(Route, { index: true, element: _jsx(GetStartedApp, { groupId: groupId }, void 0) }, void 0) }, void 0) }), void 0)] }), void 0));
};
export default GetStarted;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
